module.exports = __webpack_public_path__ + "media/brands/google-icon-501a643d.svg";